import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center mb-6 md:mb-8 lg:mb-10">
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl flex items-center justify-center">
          <Icon name="Sparkles" size={40} color="var(--color-primary)" />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground mb-3">
        Join Nubi Today
      </h1>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-md mx-auto">
        Create your account and start sharing your moments with the world
      </p>
    </div>
  );
};

export default RegistrationHeader;